import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

import './Blogdetails.css'; // We will create this CSS file next
import Navbar from '../../../components/Navbar/Navbar';
import Footer from '../../../components/Footer/Footer';
import { FaTwitter, FaFacebook, FaLinkedin, FaLink } from 'react-icons/fa';

// --- Configuration ---
const API_BASE_URL = 'https://api.hitkarihospital.com:5005';
const DEFAULT_IMAGE = 'https://via.placeholder.com/1200x500.png?text=Image+Not+Found';

// --- Helper Components ---
const ScrollProgressBar = () => {
    const [scrollProgress, setScrollProgress] = useState(0);

    const handleScroll = () => {
        const docElement = document.documentElement;
        const scrolled = docElement.scrollTop;
        const maxHeight = docElement.scrollHeight - docElement.clientHeight;
        const scrollPercent = (scrolled / maxHeight) * 100;
        setScrollProgress(scrollPercent);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        // Cleanup function to remove the event listener
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="scroll-progress-container">
            <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }}></div>
        </div>
    );
};

const BlogDetail = () => {
    const { blogId } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [readingTime, setReadingTime] = useState(0);

    useEffect(() => {
        const fetchBlogDetail = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${API_BASE_URL}/api/blogs/${blogId}`);
                const blogData = response.data;
                setBlog(blogData);
                
                // Calculate reading time (words per minute)
                const wordsPerMinute = 200;
                const textLength = blogData.description.split(' ').length;
                setReadingTime(Math.ceil(textLength / wordsPerMinute));

            } catch (err) {
                setError('Blog not found or an error occurred.');
            } finally {
                setLoading(false);
            }
        };
        fetchBlogDetail();
    }, [blogId]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!'); // Simple feedback
    };

    if (loading) return <div className="blog-detail-status">Loading article...</div>;
    if (error) return <div className="blog-detail-status blog-detail-error">{error}</div>;
    if (!blog) return <div className="blog-detail-status">Blog post not found.</div>;

    const blogImage = blog.picture ? `${API_BASE_URL}/blog/${blog.picture}` : DEFAULT_IMAGE;
    const blogUrl = window.location.href;

    return (
        <>
            <ScrollProgressBar />
            <div className="main-wrapper">
                <header className="header"><Navbar /></header>
                <div className="breadcrumb-bar">
                    <div className="container-fluid">
                        <nav aria-label="breadcrumb" className="page-breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog">Blog</Link></li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <main className="blog-detail-content">
                    <article className="blog-detail-container">
                        <header className="blog-detail-header">
                            <span className="blog-detail-category">{blog.category || 'Updates'}</span>
                            <h1 className="blog-detail-title">{blog.title}</h1>
                            <div className="blog-detail-meta">
                                <span>By <strong>{blog.authorName || 'Admin'}</strong></span>
                                <span className="blog-detail-separator">•</span>
                                <span>{new Date(blog.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                <span className="blog-detail-separator">•</span>
                                <span className="blog-detail-reading-time">{readingTime} min read</span>
                            </div>
                        </header>

                        <figure className="blog-detail-figure">
                            <img src={blogImage} alt={blog.title} className="blog-detail-image" onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_IMAGE; }}/>
                        </figure>

                        <div className="blog-detail-body" dangerouslySetInnerHTML={{ __html: blog.description }} />
                        
                        <footer className="blog-detail-footer">
                            <div className="social-share">
                                <h4>Share this article</h4>
                                <div className="social-share-buttons">
                                    <a href={`https://twitter.com/intent/tweet?url=${blogUrl}&text=${encodeURIComponent(blog.title)}`} target="_blank" rel="noopener noreferrer" aria-label="Share on Twitter"><FaTwitter /></a>
                                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${blogUrl}`} target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook"><FaFacebook /></a>
                                    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${blogUrl}&title=${encodeURIComponent(blog.title)}`} target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn"><FaLinkedin /></a>
                                    <button onClick={copyToClipboard} aria-label="Copy link"><FaLink /></button>
                                </div>
                            </div>
                        </footer>
                    </article>
                    
               
                </main>
                <Footer />
            </div>
        </>
    );
};

export default BlogDetail;